import React, { useEffect, useRef, useState } from "react";
import ArrowLeftIcon from ".././images/ArrowLeftIcon";
import ArrowRightIcon from ".././images/ArrowRightIcon";
import FilterSortIcon from ".././images/FilterSortIcon";
import "../index.css";
import TagStatus from "./TagStatus";
import EmptyTableIcon from "../images/EmptyTable";
import PlusIcon from "../images/PlusIcon";
import { webNavigate } from "../services/navigate.service";
import OptionIcon from "../images/OptionIcon";
import EditIcon from "../images/EditIcon";
import RedDeleteIcon from "../images/RedDeleteIcon";
import PlusCreateIcon from "../images/PlusCreateIcon";
import TableSkeleton from "./TableSkeleton";
import CancelIcon from "../images/CancelIcon";
import FlagIcon from "../images/FlagIcon";
import CheckIcon from "../images/CheckIcon";
import SalesIcons from "../images/SalesIcons";
import DotIcon from "../images/DotIcon";
import ArrowClientsIcon from "../images/ArrowClientsIcon";
import DownloadIcon from "../images/DownloadIcon";

interface PropTable {
    data_table?: Record<string, any>[];
    loading: boolean,
    hiddenLedger?: boolean,
    hiddenAsset?: boolean,
    PER_PAGE?: any,
    languages?: any;
    noRedirect?: boolean,
    listLedger?: any,
    listAsset?: any,
    typeAsset?: any,
    optionSelect?: boolean,
    pageClick?: any;
    actionCompany?: {
        check: boolean;
        name: string;
    }
    actionFloor?: {
        check: boolean;
        name: string;
    }
    hiddenAction?: boolean,
    count: number;
    noNagivateClick?: {
        check: boolean;
        name?: string;
    };
    path?: string;
    titleCreate?: {
        title?: string;
        path?: string;
        desc?: string;
        titleCreate?: string;
    };
    handleSendPageNumber: (pageNumber: number) => void;
    handleDelete?: (id: string) => void;
    handlePeriod?: (id: string) => void;
    handleLocation?: (id: string) => void;
    handleUser?: (id: string) => void;
    handleYear?: (id: string) => void;
    handleRedirect?: (id: string) => void;
    handleDeletePurchase?: (id: string, type: string) => void;
}

const TableReport = ({ actionFloor, handleYear, listAsset, listLedger, typeAsset, data_table, count, titleCreate, handleDelete, handleLocation, handleUser, handlePeriod, handleSendPageNumber, path, optionSelect, hiddenAction, hiddenAsset, loading, handleDeletePurchase, noRedirect, handleRedirect, noNagivateClick, actionCompany, languages, PER_PAGE, pageClick, hiddenLedger }: PropTable) => {
    const monthRef = useRef<HTMLDivElement>(null);
    const clientRef = useRef<HTMLDivElement>(null);
    const locationId = localStorage.getItem("locationId") ?? '';
    const [data, setData] = useState<Record<string, any>[]>();
    const [searchCountry, setSearchCountry] = useState("");
    const [searchYear, setSearchYear] = useState("");
    const [isMonthDropdownOpen, setIsMonthDropdownOpen] = useState(false);
    const [selectedMonth, setSelectedMonth] = useState<string>("");
    const [isClientDropdownOpen, setIsClientDropdownOpen] = useState(false);
    const [selectedClient, setSelectedClient] = useState<string>("");
    const dropdownCountryRef = useRef<HTMLDivElement>(null);
    const dropdownYearRef = useRef<HTMLDivElement>(null);
    const [isCountryDropdownOpen, setIsCountryDropdownOpen] = useState(false);
    const [isYearDropdownOpen, setIsYearDropdownOpen] = useState(false);
    const preLanguage = localStorage.getItem("language");
    const [showActions, setShowActions] = useState<boolean[]>(data ? new Array(data.length).fill(false) : []);
    const actionRefs = useRef<(HTMLDivElement | null)[]>([]);
    const [pageNumber, setPageNumber] = useState<number>(pageClick);
    const [checkClient, setCheckClient] = useState<any>({ checkValue: false, name: "" });
    const totalPages = data ? Math.ceil(count / PER_PAGE) : 0;
    const pages = Array.from({ length: totalPages }, (_, index) => index + 1);
    const startItem = (pageNumber - 1) * PER_PAGE;
    const endItem = Math.min(pageNumber * PER_PAGE, count);
    let numberOfKeys = data && data[0] ? Object.keys(data[0]) : [];
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            actionRefs.current.forEach((ref, index) => {
                if (ref && !ref.contains(event.target as Node)) {
                    setShowActions(prev => {
                        const newShowActions = [...prev];
                        newShowActions[index] = false;
                        return newShowActions;
                    });
                }
            });
            if (monthRef.current && !monthRef.current.contains(event.target as Node)) {
                setIsMonthDropdownOpen(false);
            }
            if (clientRef.current && !clientRef.current.contains(event.target as Node)) {
                setIsClientDropdownOpen(false);
            }
            if (dropdownCountryRef.current && !dropdownCountryRef.current.contains(event.target as Node)) {
                setIsCountryDropdownOpen(false);
            }
            if (dropdownYearRef.current && !dropdownYearRef.current.contains(event.target as Node)) {
                setIsYearDropdownOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const handleNextPage = () => {
        if (pageNumber < totalPages) {
            setPageNumber(pageNumber + 1);
            handleSendPageNumber(pageNumber + 1)
        } else {
            setPageNumber(1);
            handleSendPageNumber(1)
        }

    };

    const handleSelectDelete = (id: string) => {
        if (handleDelete) {
            handleDelete(id);
        }
    }

    const handleLanguageShow = (id: string) => {
        if (handleRedirect) {
            handleRedirect(id);
        }
    }

    const toggleAction = (index: number) => {
        setShowActions((prev) => {
            const newShowActions = [...prev];
            newShowActions[index] = !newShowActions[index];
            return newShowActions;
        });
    };

    const handleSelectPurchase = (id: string, type: string, index: number) => {
        if (handleDeletePurchase) {
            setShowActions((prev) => {
                const newShowActions = [...prev];
                newShowActions[index] = !newShowActions[index];
                return newShowActions;
            });
            handleDeletePurchase(id, type);
        }
    };

    const handlePreviousPage = () => {
        if (pageNumber > totalPages) {
            setPageNumber(pageNumber - 1);
            handleSendPageNumber(pageNumber - 1)
        } else {
            setPageNumber(1);
            handleSendPageNumber(1)
        }
    };

    const handlePageClick = (page: number) => {
        setPageNumber(page);
        handleSendPageNumber(page);
    };

    const handleSelectYear = (year: any) => {
        setSearchYear(year === "year" ? "" : year.year);
        setIsYearDropdownOpen(false);
        if (handleYear) {
            handleYear(year === "year" ? "year" : year.year);
        }
    };
    const handleSelectPeriod = (month: any) => {
        setSelectedMonth(month === "period" ? "" : String(month.transactionYear + ' - ' + month.monthSequence));
        setIsMonthDropdownOpen(false);
        if (handlePeriod) {
            handlePeriod(month === "period" ? "period" : month.id);
        }
    };

    const handleSelectType = (type: any) => {
        setSelectedMonth(type === "type" ? "" : String(type.name));
        setIsMonthDropdownOpen(false);
        if (handlePeriod) {
            handlePeriod(type === "type" ? "type" : type.value);
        }
    };


    const handleSelectLocation = (location: any) => {
        setSearchCountry(location === "location" ? "" : location.name);
        setIsCountryDropdownOpen(false);
        if (handleLocation) {
            handleLocation(location === "location" ? "location" : location.id);
        }
    };
    const handleSelectUser = (user: any) => {
        setSelectedClient(user === "user" ? "" : String(user.user.firstName + ' ' + user.user.lastName));
        setIsClientDropdownOpen(false);
        if (handleUser) {
            handleUser(user === "user" ? "user" : user.userId);
        }
    };

    useEffect(() => {
        if (locationId !== "") {
            setSearchCountry(listLedger?.location.filter((v: any) => v?.id === locationId)?.[0]?.name)
        }
    }, [listLedger?.location])

    useEffect(() => {
        setData(data_table);
    }, [data_table])
    useEffect(() => {
        setPageNumber(pageClick);
    }, [pageClick])
    return (
        <>
            <div className="relative max-lg:hidden" style={{ height: noNagivateClick?.check ? "calc(42% - 100px)" : "calc(100% - 80px)" }} >
                {
                    loading
                        ?
                        <div style={{ marginTop: '24px' }}>
                            <TableSkeleton rows={8} columns={6} showHeader />
                        </div>
                        :
                        <>
                            <div style={{ marginTop: '24px' }}>
                                <div className={` flex items-center ${noNagivateClick?.check || actionCompany || hiddenLedger || hiddenAsset || actionFloor ? " justify-between " : "justify-end "}`}>
                                    {actionCompany?.check &&
                                        // <div className="flex items-center cursor-pointer" onClick={() => handleCheckActive(noNagivateClick?.name)}>
                                        <>
                                            {
                                                actionCompany?.name === "Billing History" &&
                                                <div className="flex items-center">
                                                    <p className="font-inter" style={{ color: "#2A2A2A", fontSize: "16px", fontWeight: "600", lineHeight: "20.8px" }}>{actionCompany?.name}</p>
                                                </div>
                                            }
                                            {
                                                actionCompany?.name !== "Billing History" &&
                                                <div className="cursor-pointer flex items-center justify-center" style={{ padding: "4px 12px", borderRadius: "6px", backgroundColor: "#3AC0C4", height: "36px" }} onClick={() => { webNavigate("/" + preLanguage + path + "new") }} >
                                                    <p className="font-inter" style={{ color: "#2A2A2A", fontSize: "14px", fontWeight: "600", lineHeight: "20.8px" }}> + {actionCompany?.name}</p>
                                                </div>
                                            }
                                        </>
                                    }
                                    {
                                        actionFloor?.check &&
                                        <div className="cursor-pointer flex items-center justify-center" style={{ padding: "4px 12px", borderRadius: "6px", backgroundColor: "#3AC0C4", height: "36px" }} onClick={() => { webNavigate("/" + preLanguage + path + "new") }} >
                                            <p className="font-inter" style={{ color: "#2A2A2A", fontSize: "14px", fontWeight: "600", lineHeight: "20.8px" }}> + {actionFloor?.name}</p>
                                        </div>
                                    }
                                </div>
                            </div>
                            {(hiddenAsset || hiddenLedger || (data && data.length > 0)) ?
                                <>
                                    <div style={{ marginTop: "24px" }}>
                                        <div className={` flex items-center ${noNagivateClick?.check || actionCompany || hiddenLedger || hiddenAsset || actionFloor ? " justify-between " : "justify-end "}`}>
                                            {/* {optionSelect &&
                                                <div className="rounded flex items-center gap-x-2 bg-white h-10" style={{ padding: "0px 12px" }}>
                                                    <p className="text-[14px] font-inter leading-[28px]" style={{ color: "#424242" }}>Select month</p>
                                                    <div className="cursor-pointer" style={{ rotate: "90deg" }} >
                                                        <ArrowRightIcon />
                                                    </div>
                                                </div>
                                            } */}
                                            {
                                                (hiddenAsset && listAsset && listAsset.length) > 0 &&
                                                <div className="relative" ref={dropdownYearRef}>
                                                    <input
                                                        tabIndex={13}
                                                        type="text"
                                                        value={searchYear}
                                                        style={{ pointerEvents: 'all', width: "180px" }}
                                                        onChange={(e) => {
                                                            setSearchYear(e.target.value);
                                                            setIsYearDropdownOpen(true);
                                                        }}
                                                        onClick={() => setIsYearDropdownOpen(true)}
                                                        className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-lg outline-none focus-none bg-white`}
                                                    />
                                                    {isYearDropdownOpen && (
                                                        <div className="absolute z-10 mt-1 bg-white border border-[#EBEBED] rounded-lg max-h-60 overflow-auto p-1 shadow-extend" style={{ width: "180px" }}>
                                                            <div
                                                                style={{ padding: "8px 6px", borderRadius: "4px" }}
                                                                className="cursor-pointer hover:bg-[#E7F1F1] text-main text-[14px] font-inter duration-300"
                                                                onClick={() => handleSelectYear("year")}
                                                            >
                                                                Select year
                                                            </div>
                                                            {listAsset
                                                                .map((asset: any) => (
                                                                    <div
                                                                        key={asset?.id}
                                                                        style={{ padding: "8px 6px", borderRadius: "4px" }}
                                                                        className="cursor-pointer hover:bg-[#E7F1F1] text-main text-[14px] font-inter duration-300"
                                                                        onClick={() => handleSelectYear(asset)}
                                                                    >
                                                                        {asset?.year}
                                                                    </div>
                                                                ))
                                                            }
                                                        </div>
                                                    )}
                                                </div>
                                            }
                                            {
                                                hiddenLedger &&
                                                <div className="flex items-center" style={{ gap: "12px" }}>
                                                    {
                                                        listLedger?.period &&
                                                        <div className="relative" ref={monthRef}>
                                                            <input
                                                                type="text"
                                                                value={selectedMonth}
                                                                onChange={(e) => {
                                                                    setSelectedMonth(e.target.value);
                                                                    setIsMonthDropdownOpen(true);
                                                                }}
                                                                onClick={() => setIsMonthDropdownOpen(true)}
                                                                style={{ pointerEvents: 'all', width: "180px" }}
                                                                tabIndex={11}
                                                                className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-lg outline-none focus-none bg-white`}
                                                            />
                                                            {isMonthDropdownOpen && (
                                                                <div className="absolute z-[100] mt-1 bg-white border border-[#EBEBED] rounded-lg p-1 shadow-extend" style={{ width: "180px" }}>
                                                                    <div className="w-full h-full relative">
                                                                        <div
                                                                            style={{ padding: "8px 6px", borderRadius: "4px" }}
                                                                            className="cursor-pointer hover:bg-[#E7F1F1] text-main text-[14px] font-inter duration-300"
                                                                            onClick={() => handleSelectPeriod("period")}
                                                                        >
                                                                            Select period
                                                                        </div>
                                                                        {listLedger?.period
                                                                            .map((month: any) => (
                                                                                <div
                                                                                    key={month}
                                                                                    style={{ padding: "8px 6px", borderRadius: "4px" }}
                                                                                    className="cursor-pointer hover:bg-[#E7F1F1] text-main text-[14px] font-inter duration-300"
                                                                                    onClick={() => handleSelectPeriod(month)}
                                                                                >
                                                                                    {month.transactionYear} -  {month.monthSequence}
                                                                                </div>
                                                                            ))}

                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                    }

                                                    {
                                                        listLedger?.location &&
                                                        <div className="relative" ref={dropdownCountryRef}>
                                                            <input
                                                                tabIndex={13}
                                                                type="text"
                                                                value={searchCountry}
                                                                style={{ pointerEvents: 'all', width: "180px" }}
                                                                onChange={(e) => {
                                                                    setSearchCountry(e.target.value);
                                                                    setIsCountryDropdownOpen(true);
                                                                }}
                                                                onClick={() => setIsCountryDropdownOpen(true)}
                                                                className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-lg outline-none focus-none bg-white`}
                                                            />
                                                            {isCountryDropdownOpen && (
                                                                <div className="absolute z-10 mt-1 bg-white border border-[#EBEBED] rounded-lg max-h-60 overflow-auto p-1 shadow-extend" style={{ width: "180px" }}>
                                                                    {listLedger?.location
                                                                        .map((country: any) => (
                                                                            <div
                                                                                key={country?.id}
                                                                                style={{ padding: "8px 6px", borderRadius: "4px" }}
                                                                                className="cursor-pointer hover:bg-[#E7F1F1] text-main text-[14px] font-inter duration-300"
                                                                                onClick={() => handleSelectLocation(country)}
                                                                            >
                                                                                {country?.name}
                                                                            </div>
                                                                        ))
                                                                    }
                                                                </div>
                                                            )}
                                                        </div>
                                                    }
                                                    {
                                                        listLedger?.type &&
                                                        <div className="relative" ref={monthRef}>
                                                            <input
                                                                type="text"
                                                                value={selectedMonth}
                                                                onChange={(e) => {
                                                                    setSelectedMonth(e.target.value);
                                                                    setIsMonthDropdownOpen(true);
                                                                }}
                                                                onClick={() => setIsMonthDropdownOpen(true)}
                                                                style={{ pointerEvents: 'all', width: "180px" }}
                                                                tabIndex={11}
                                                                className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-lg outline-none focus-none bg-white`}
                                                            />
                                                            {isMonthDropdownOpen && (
                                                                <div className="absolute z-[100] mt-1 bg-white border border-[#EBEBED] rounded-lg p-1 shadow-extend" style={{ width: "180px" }}>
                                                                    <div className="w-full h-full relative">
                                                                        <div
                                                                            style={{ padding: "8px 6px", borderRadius: "4px" }}
                                                                            className="cursor-pointer hover:bg-[#E7F1F1] text-main text-[14px] font-inter duration-300"
                                                                            onClick={() => handleSelectType("type")}
                                                                        >
                                                                            Select type
                                                                        </div>
                                                                        {listLedger?.type
                                                                            .map((type: any) => (
                                                                                <div
                                                                                    key={type}
                                                                                    style={{ padding: "8px 6px", borderRadius: "4px" }}
                                                                                    className="cursor-pointer hover:bg-[#E7F1F1] text-main text-[14px] font-inter duration-300"
                                                                                    onClick={() => handleSelectType(type)}
                                                                                >
                                                                                    {type.name}
                                                                                </div>
                                                                            ))}

                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                    }
                                                    {
                                                        listLedger?.clients &&
                                                        <div className="relative" ref={clientRef}>
                                                            <input
                                                                type="text"
                                                                value={selectedClient}
                                                                onChange={(e) => {
                                                                    setSelectedClient(e.target.value);
                                                                    setIsClientDropdownOpen(true);
                                                                }}
                                                                onClick={() => setIsClientDropdownOpen(true)}
                                                                style={{ pointerEvents: 'all', width: "180px" }}
                                                                tabIndex={11}
                                                                className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-lg outline-none focus-none bg-white`}
                                                            />
                                                            {isClientDropdownOpen && (
                                                                <div className="absolute z-[100] mt-1 bg-white border border-[#EBEBED] rounded-lg p-1 shadow-extend" style={{ width: "180px" }}>
                                                                    <div className="w-full h-full relative">
                                                                        <div
                                                                            style={{ padding: "8px 6px", borderRadius: "4px" }}
                                                                            className="cursor-pointer hover:bg-[#E7F1F1] text-main text-[14px] font-inter duration-300"
                                                                            onClick={() => handleSelectUser("user")}
                                                                        >
                                                                            Select user
                                                                        </div>
                                                                        {listLedger?.clients
                                                                            .map((user: any) => (
                                                                                <div
                                                                                    key={user}
                                                                                    style={{ padding: "8px 6px", borderRadius: "4px" }}
                                                                                    className="cursor-pointer hover:bg-[#E7F1F1] text-main text-[14px] font-inter duration-300"
                                                                                    onClick={() => handleSelectUser(user)}
                                                                                >
                                                                                    {(user.user.firstName + ' ' + user.user.lastName)}
                                                                                </div>
                                                                            ))}

                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                    }
                                                </div>
                                            }
                                            {noNagivateClick?.check &&
                                                // <div className="flex items-center cursor-pointer" onClick={() => handleCheckActive(noNagivateClick?.name)}>
                                                <div className="flex items-center cursor-pointer">
                                                    <div className="flex items-center justify-center" style={{ width: "32px", height: "32px", padding: "4px", rotate: checkClient?.checkValue ? "180deg" : "0deg", transition: "0.3s ease-in-out" }}>
                                                        <ArrowClientsIcon />
                                                    </div>
                                                    <p className="font-inter" style={{ color: "#2A2A2A", fontSize: "18px", fontWeight: "400", lineHeight: "23.4px" }}>{noNagivateClick?.name}</p>
                                                </div>
                                            }
                                            <div className="flex items-center gap-x-3">
                                                <p className="text-[14px] leading-[130%] font-inter text-main">
                                                    {startItem + 1}-{endItem} of {count}
                                                </p>
                                                <div className="flex items-center">
                                                    <div className="cursor-pointer" onClick={handlePreviousPage}>
                                                        <ArrowLeftIcon />
                                                    </div>
                                                    <div className="flex items-center gap-x-3">
                                                        {pages.map((page) => (
                                                            <div
                                                                key={page}
                                                                className={`cursor-pointer w-6 h-10 hover:bg-[#E7F1F1] hover:text-[#078D91] duration-300 rounded-md flex items-center justify-center text-[14px] leading-[130%] font-inter ${page === pageNumber
                                                                    ? "bg-[#E7F1F1] text-[#078D91]"
                                                                    : "text-[#495057]"
                                                                    }`}
                                                                onClick={() => handlePageClick(page)}
                                                            >
                                                                {page}
                                                            </div>
                                                        ))}
                                                    </div>
                                                    <div className="cursor-pointer" onClick={handleNextPage}>
                                                        <ArrowRightIcon />
                                                    </div>
                                                </div>
                                                <div className="cursor-pointer" onClick={handlePreviousPage}>
                                                    <FilterSortIcon />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div
                                        className="bg-white rounded-md w-full overflow-hidden"
                                        style={{ marginTop: "12px", height: "100%" }}
                                    >
                                        <div className="w-full h-10 bg-[#E7F1F1] itmes-center gap-x-5 lg:flex hidden">
                                            <div className="flex items-center" style={{
                                                width: (!hiddenAction || hiddenLedger) ? `calc((100% - 48px))` : "100%",
                                            }}
                                            >
                                                {numberOfKeys.map((val: string) => {
                                                    if (val !== "id" && val !== "default") {
                                                        return (
                                                            <div
                                                                key={val}
                                                                className="text-[12px] font-semibold leading-[18px] font-inter flex items-center h-full"
                                                                style={{
                                                                    color: "#898989",
                                                                    width: `calc(100% / ${numberOfKeys.length - 1})`,
                                                                    padding: '0px 8px'
                                                                }}
                                                            >
                                                                {languages && languages[val] ? languages[val] : val}
                                                            </div>
                                                        )
                                                    }
                                                })}
                                            </div>
                                        </div>
                                        <div style={{ height: "calc(100% - 40px)", overflowY: "scroll", scrollbarWidth: "none", msOverflowStyle: "none" }}>
                                            {data?.map((v: any, i: number) => {
                                                return (
                                                    <div
                                                        className={`w-full h-10 flex items-center group table_hover duration-300 `}
                                                        key={i}
                                                        style={{
                                                            cursor: actionCompany?.name !== "Billing History" || hiddenAction || v["Status"] === "In progress" || v["Status"] === "To be reviewed" || !noRedirect || !hiddenLedger ? "pointer" : "default"
                                                        }}
                                                        onClick={() => {
                                                            const shouldNavigate =
                                                                hiddenAction ||
                                                                (actionCompany?.check && ["New User", "New Location"].includes(actionCompany.name));
                                                            if (typeAsset) {
                                                                window.noContext = { No: v?.No, setNo: () => { } }

                                                            }
                                                            if (shouldNavigate) {
                                                                webNavigate(`/${preLanguage}${path}${v?.id || ""}`);
                                                            }
                                                        }}
                                                    >
                                                        <div className={`flex items-center w-full ${hiddenAction ? "" : ""}`} onClick={() => { (v["Status"] === "In progress" || v["Status"] === "To be reviewed" && !noRedirect) ? webNavigate("/" + preLanguage + path + v?.id) : null }}>
                                                            {numberOfKeys.map((key, idx) => {
                                                                const value = Object.values(v)[idx];

                                                                if (key !== "id" && key !== "Status" && key !== "default" && key !== "Icon") {
                                                                    return (
                                                                        <div
                                                                            key={idx}
                                                                            className="text-[14px] table_hover_text group-hover:text-[#1E1E36] duration-300 leading-[18px] font-inter flex items-center h-full"
                                                                            style={{
                                                                                width: `calc(100% / ${numberOfKeys.length - 1})`,
                                                                                padding: '0px 8px',
                                                                            }}
                                                                        >
                                                                            <p
                                                                                style={{
                                                                                    whiteSpace: "nowrap",
                                                                                    overflow: "hidden",
                                                                                    textOverflow: "ellipsis",
                                                                                }}
                                                                            >
                                                                                {typeof value === "object" ? (
                                                                                    <pre>{JSON.stringify(value)}</pre>
                                                                                ) : (
                                                                                    String(value)
                                                                                )}
                                                                            </p>
                                                                        </div>
                                                                    );
                                                                } else if (key === "Status") {
                                                                    return (
                                                                        <div
                                                                            key={idx}
                                                                            className="text-[14px] leading-[15.6px] font-inter h-full flex items-center justify-between"
                                                                            style={{
                                                                                width: `calc(100% / ${numberOfKeys.length - 1})`,
                                                                            }}
                                                                        >
                                                                            <TagStatus value={String(value)} />
                                                                            {
                                                                                v["Status"] === "To be reviewed" ?
                                                                                    <>
                                                                                        {v["default"] === "Approved" ? <FlagIcon check={true} /> : <FlagIcon check={false} />}
                                                                                    </>
                                                                                    :
                                                                                    <></>
                                                                            }
                                                                        </div>
                                                                    );
                                                                } else if (key === "Icon") {
                                                                    return (
                                                                        <div
                                                                            key={idx}
                                                                            className="text-[14px] leading-[15.6px] font-inter h-full flex items-center justify-between"
                                                                            style={{
                                                                                width: `calc(100% / ${numberOfKeys.length - 1})`,
                                                                            }}
                                                                        >
                                                                            <img src={String(value)} alt="Uploaded Preview" style={{ height: '24px', objectFit: "contain", width: "24px" }} />
                                                                        </div>
                                                                    );
                                                                }
                                                            })}
                                                        </div>
                                                        {
                                                            actionCompany?.check &&
                                                            <div style={{
                                                                width: "48px",
                                                                cursor: "pointer"
                                                            }}>
                                                                {actionCompany?.name === "Billing History" &&
                                                                    <div className="flex items-center gap-x-2 cursor-pointer" style={{ width: "20px", height: "20px" }}>
                                                                        <DownloadIcon />
                                                                    </div>
                                                                }
                                                            </div>
                                                        }
                                                        {
                                                            !hiddenAction && !actionCompany?.check && !hiddenLedger && !hiddenAsset &&
                                                            <div
                                                                className="relative cursor-pointer"
                                                                style={{
                                                                    width: "48px",
                                                                }}
                                                                onClick={() => toggleAction(i)}
                                                            >
                                                                {
                                                                    v["Status"] === "In progress" ?
                                                                        <div
                                                                            onClick={() => { handleSelectPurchase(v?.id, "canceled", i) }}
                                                                            className="hover:bg-[#E7F1F1] cursor-pointer duration-300 flex items-center gap-x-2"
                                                                            style={{ borderRadius: "4px", padding: "4px", height: "24px", width: "24px" }}
                                                                        >
                                                                            <CancelIcon />
                                                                        </div>
                                                                        :
                                                                        <div>
                                                                            <OptionIcon />
                                                                            {v["Status"] === "To be reviewed" ?
                                                                                <div
                                                                                    className={`absolute rounded-lg p-1 bg-white shadow_option space-y-1 right-full z-[200] transition-all duration-300 ease-in-out ${showActions[i] ? "opacity-100 translate-x-0" : "opacity-0 translate-x-4 pointer-events-none"
                                                                                        }`}
                                                                                    style={{ width: "147px", right: "100%" }}
                                                                                    ref={(el) => actionRefs.current[i] = el}
                                                                                >
                                                                                    <div
                                                                                        onClick={() => { handleSelectPurchase(v?.id, "approved", i) }}
                                                                                        className="hover:bg-[#E7F1F1] cursor-pointer duration-300 w-full flex items-center gap-x-2"
                                                                                        style={{ borderRadius: "4px", padding: "8px 6px" }}
                                                                                    >
                                                                                        <CheckIcon />
                                                                                        <p className="text-[14px] leading-[20px] text-main font-inter">{languages && languages["Approve"] ? languages["Approve"] : "Approve"}</p>
                                                                                    </div>
                                                                                    <div
                                                                                        className="hover:bg-[#E40F03] cursor-pointer duration-300 w-full flex items-center gap-x-2"
                                                                                        style={{ borderRadius: "4px", padding: "8px 6px" }}
                                                                                        onClick={() => { handleSelectPurchase(v?.id, "canceled", i) }}
                                                                                    >
                                                                                        <CancelIcon />
                                                                                        <p className="text-[14px] leading-[20px] font-inter" style={{ color: "#E40F03" }}>{languages && languages["Cancel"] ? languages["Cancel"] : "Cancel"}</p>
                                                                                    </div>
                                                                                </div>
                                                                                :
                                                                                <div
                                                                                    className={`absolute rounded-lg p-1 bg-white shadow_option space-y-1 right-full z-[200] transition-all duration-300 ease-in-out ${showActions[i] ? "opacity-100 translate-x-0" : "opacity-0 translate-x-4 pointer-events-none"
                                                                                        }`}
                                                                                    ref={(el) => actionRefs.current[i] = el}
                                                                                    style={{ width: "147px", right: "100%" }}
                                                                                >
                                                                                    <div
                                                                                        onClick={() => { noRedirect ? handleLanguageShow(v?.id) : webNavigate("/" + preLanguage + path + v?.id) }}
                                                                                        className="hover:bg-[#E7F1F1] cursor-pointer duration-300 w-full flex items-center gap-x-2"
                                                                                        style={{ borderRadius: "4px", padding: "8px 6px" }}
                                                                                    >
                                                                                        <EditIcon />
                                                                                        <p className="text-[14px] leading-[20px] text-main font-inter">{languages && languages["Edit"] ? languages["Edit"] : "Edit"}</p>
                                                                                    </div>
                                                                                    <div
                                                                                        className="hover:bg-[#E7F1F1] cursor-pointer duration-300 w-full flex items-center gap-x-2"
                                                                                        style={{ borderRadius: "4px", padding: "8px 6px" }}
                                                                                        onClick={() => { handleSelectDelete(v?.id) }}
                                                                                    >
                                                                                        <RedDeleteIcon />
                                                                                        <p className="text-[14px] leading-[20px] text-main font-inter">{languages && languages["Delete"] ? languages["Delete"] : "Delete"}</p>
                                                                                    </div>
                                                                                </div>
                                                                            }

                                                                        </div>
                                                                }
                                                            </div>
                                                        }
                                                        {
                                                            (hiddenLedger || hiddenAsset) &&
                                                            (<div
                                                                className="relative cursor-pointer"
                                                                style={{
                                                                    width: "48px",
                                                                }}
                                                            >
                                                            </div>)
                                                        }
                                                    </div>
                                                );
                                            })}

                                        </div>

                                    </div>
                                </>
                                :
                                <>
                                    <div className="flex justify-center items-center h-full" style={{ flexDirection: "column" }}>
                                        <EmptyTableIcon />
                                        <p>{titleCreate?.title}</p><br />
                                        <p>{titleCreate?.desc}</p>
                                        {titleCreate?.titleCreate &&
                                            <div className="flex items-center gap-x-2 cursor-pointer" onClick={() => { webNavigate("/" + preLanguage + titleCreate.path) }}>
                                                <PlusCreateIcon />
                                                <p className="text-[14px] leading-[20px] text-main font-inter" style={{ color: "#078D91" }}>{titleCreate.titleCreate}</p>
                                            </div>
                                        }
                                    </div>
                                </>
                            }
                        </>

                }
            </div >
        </>

    );
};

export default TableReport;
